export const logo = require("./picklogo.png");
export const profile_brand = require("./profile/brand.png");
export const profile_pink = require("./profile/pink.png");
export const profile_yellow = require("./profile/yellow.png");
export const profile_green = require("./profile/green.png");
export const profile_blue = require("./profile/blue.png");
